import React from 'react';
import { Section } from './ui/Section';
import { HelpCircle, Clock, Search, TrendingDown } from 'lucide-react';
export function ProblemSection() {
  return <Section id="problema" className="bg-brand-dark relative border-t border-white/5" data-id="element-237">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-accent/20 to-transparent" data-id="element-238"></div>

      <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-239">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand-surface border border-white/10 mb-6" data-id="element-240">
          <HelpCircle className="w-6 h-6 text-brand-accent" data-id="element-241" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-242">
          ¿Te Suena Familiar Alguna de Estas Situaciones?
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-243">
        <div className="bg-brand-surface/50 border border-white/5 p-8 rounded-2xl hover:border-brand-accent/30 transition-colors" data-id="element-244">
          <Clock className="w-8 h-8 text-brand-accent mb-4" data-id="element-245" />
          <p className="text-lg text-slate-300 leading-relaxed" data-id="element-246">
            Llevas meses (o años) trabajando duro en tu negocio. Tienes clientes
            que están felices con tus resultados. Tienes testimonios. Tienes
            experiencia real.
          </p>
        </div>

        <div className="bg-brand-surface/50 border border-white/5 p-8 rounded-2xl hover:border-brand-accent/30 transition-colors" data-id="element-247">
          <Search className="w-8 h-8 text-brand-accent mb-4" data-id="element-248" />
          <p className="text-lg text-slate-300 leading-relaxed" data-id="element-249">
            Pero cuando alguien nuevo te busca online... la imagen que proyectas{' '}
            <strong className="text-white" data-id="element-250">no refleja ni la mitad</strong> de lo
            que realmente eres.
          </p>
        </div>

        <div className="bg-brand-surface/50 border border-white/5 p-8 rounded-2xl md:col-span-2 hover:border-brand-accent/30 transition-colors text-center" data-id="element-251">
          <TrendingDown className="w-8 h-8 text-brand-accent mb-4 mx-auto" data-id="element-252" />
          <p className="text-xl text-slate-300 leading-relaxed max-w-2xl mx-auto" data-id="element-253">
            Tu web parece desactualizada. O peor: no tienes web y dependes
            completamente de las redes sociales o del boca a boca.
          </p>
          <div className="mt-8 p-6 bg-brand-dark rounded-xl border border-red-500/20" data-id="element-254">
            <p className="text-xl font-semibold text-white" data-id="element-255">
              Y en el fondo sabes lo que eso significa:{' '}
              <br className="hidden sm:block" data-id="element-256" />
              <span className="text-red-400" data-id="element-257">
                Estás dejando ir clientes todos los días sin ni siquiera
                saberlo.
              </span>
            </p>
          </div>
        </div>
      </div>
    </Section>;
}